import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Material UI
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';

// Styling
import styles from './styles';

class Title extends Component {
  render(){
    const { classes } = this.props;
    return(
      <Typography type="subheading" color="inherit" noWrap className={classes.header}>
        <body>DSN</body>
      </Typography>
    );
  }
}

Title.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(Title);



// WEBPACK FOOTER //
// ./src/scenes/Information/components/ApplicationBar/components/ToolBar/components/Title/index.js